<p-fieldset legend="Lotes">
  <div class="row mt-2">
    <div class="col-12">
      <button (click)="adicionar()" class="btn btn-sm btn-outline-primary mb-2" *ngIf="!itemAtual">
        <i class="fa fa-plus"></i> Adicionar
      </button>
      <button (click)="salvar()" class="btn btn-sm btn-outline-success" *ngIf="itemAtual">
        <i class="fa fa-check"></i> Salvar
      </button>
      <button (click)="cancelar()" class="btn btn-sm btn-link text-muted ml-2" *ngIf="itemAtual">
        Cancelar
      </button>
    </div>
  </div>
  <table class="table table-eddy table-sm" *ngIf="!itemAtual">
    <thead>
      <tr>
        <th style="width: 55%" scope="col">Descrição</th>
        <th style="width: 10%" scope="col">Quantidade</th>
        <th style="width: 10%" scope="col">Unidade</th>
        <th style="width: 10%" scope="col">Orçamento</th>
        <th style="width: 15%" scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of objeto.Lote">
        <td style="width: 55%">{{item.NumeroLote}} - {{item.DescricaoLote}}</td>
        <td style="width: 10%">{{item.Quantidade}}</td>
        <td style="width: 10%">{{item.UnidadeMedida}}</td>
        <td style="width: 10%">{{item.OrcamentoLoteNao}}</td>
        <td class="text-right" style="width: 15%">
          <button (click)="visualizar(item)" class="btn btn-sm btn-outline-primary mr-2">
            <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
          </button>
          <button (click)="remover(item)" class="btn btn-sm btn-outline-primary mr-2">
            <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
          </button>
        </td>
      </tr>
    </tbody>
  </table>
  <div *ngIf="itemAtual">
    <hr />
    <div class="row">
      <div class="col-md-8">
        <label for="DescricaoLote" class="required">Descrição do Lote</label>
        <textarea class="form-control" id="DescricaoLote" rows="5" [(ngModel)]="itemAtual.DescricaoLote"
          [ngModelOptions]="{standalone: true}"></textarea>
      </div>
      <div class="col-md-4">
        <div class="row">
          <div class="col-6">
            <label for="UnidadeMedida" class="required">Unidade</label>
            <input type="text" class="form-control" id="UnidadeMedida" [(ngModel)]="itemAtual.UnidadeMedida"
              [ngModelOptions]="{standalone: true}">
          </div>
          <div class="col-6">
            <label for="Quantidade" class="required">Quantidade</label>
            <input type="text" class="form-control" id="Quantidade" [(ngModel)]="itemAtual.Quantidade"
              [ngModelOptions]="{standalone: true}" unmask="typed" [imask]="imaskQtd">
          </div>
        </div>
        <div class="row mt-3">
          <label class="required float-left col-6">
            Possui Orçamento?
          </label>
          <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-6"
            [(ngModel)]="itemAtual.OrcamentoLoteNao" [ngModelOptions]="{standalone: true}">
            <ng-template let-opcao>
              <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
            </ng-template>
          </p-selectButton>
        </div>
        <div class="row mt-3 mb-3">
          <label class="required float-left col-6">
            Possui Itens?
          </label>
          <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-6"
            [(ngModel)]="itemAtual.LoteCompostoItensNao" [ngModelOptions]="{standalone: true}">
            <ng-template let-opcao>
              <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
            </ng-template>
          </p-selectButton>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <label for="TipoExecucao" class="required">Tipo de Execução</label>
        <select id="TipoExecucao" class="form-control" [(ngModel)]="itemAtual.TipoExecucao"
          [ngModelOptions]="{standalone: true}">
          <option *ngFor="let item of opcoesTipoExecucao" [ngValue]="item.id">{{item.nome}}</option>
        </select>
      </div>
      <div class="col-md-3">
        <label for="ClassificacaoEconomica" class="required">Tipo Classificação Econômica</label>
        <select id="ClassificacaoEconomica" class="form-control"
          [(ngModel)]="itemAtual.ClassificacaoEconomica.TipoClassificacaoEconomica"
          [ngModelOptions]="{standalone: true}">
          <option *ngFor="let item of opcoesReceitaDespesa" [ngValue]="item.id">{{item.nome}}</option>
        </select>
      </div>
      <div class="col-md-6">
        <label for="classificacaoCod" class="required">Código Classificação Econômica</label>
        <select id="classificacaoCod" *ngIf="itemAtual.ClassificacaoEconomica.TipoClassificacaoEconomica === 1"
          [(ngModel)]="itemAtual.ClassificacaoEconomica.CodigoClassificacaoEconomica"
          [ngModelOptions]="{standalone: true}" class="form-control float-left d-inline">
          <option *ngFor="let item of listaReceita" [ngValue]="item.id">{{item.id}} - {{item.nome}}</option>
        </select>
        <select id="classificacaoCod" *ngIf="itemAtual.ClassificacaoEconomica.TipoClassificacaoEconomica === 2"
          [(ngModel)]="itemAtual.ClassificacaoEconomica.CodigoClassificacaoEconomica"
          [ngModelOptions]="{standalone: true}" class="form-control float-left d-inline">
          <option *ngFor="let item of listaDespesa" [ngValue]="item.id">{{item.id}} - {{item.nome}}</option>
        </select>
        <button class="btn btn-sm btn-link float-right mt-2" (click)="aplicarClassificacao()">
          <i class="fa fa-reply-all"></i> Aplicar classificação a todos itens
        </button>
      </div>
    </div>
    <lib-licitacao-audesp-lote-orc *ngIf="itemAtual.OrcamentoLoteNao === 'S'" [lote]="itemAtual">
    </lib-licitacao-audesp-lote-orc>
    <lib-licitacao-audesp-lote-item *ngIf="itemAtual.LoteCompostoItensNao === 'S'" [lote]="itemAtual">
    </lib-licitacao-audesp-lote-item>
  </div>
</p-fieldset>